// // CareSummary.jsx

// import React, { useState, useEffect, useLayoutEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import SideNav from "../../Sidenav";
// import DemographicsPatientDetail from "../DemographicsPatientDetail";
// import CareSummaryWrapper from "./CareSummaryWrapper";
// import { GetSideNav } from "../../../StateManagement/Reducers/ScheduleState";
// import "./CareSummary.css";

// const CareSummary = () => {
//   const [navData1, setNavData1] = useState("iconclose");

//   const dispatch = useDispatch();

//   const NavData1 = useSelector((state) => state.Schedule?.NavData);

//   useEffect(() => {
//     if (NavData1 !== "") {
//       setNavData1(NavData1);
//     }
//   }, [NavData1]);

//   useEffect(() => {
//     dispatch(GetSideNav("demographics"));
//   }, []);

//   useLayoutEffect(() => {
//     const parentcontainer = document.querySelector(".pat-left-div");
//     const container = document.getElementById("care-summary");

//     if (parentcontainer && container) {
//       parentcontainer.style.position = "fixed";
//       parentcontainer.style.overflowY = "auto";
//       parentcontainer.style.height = "calc(100vh - 76px)";
//       parentcontainer.style.width = "16.5%";
//       parentcontainer.style.paddingRight = "0px";

//       container.style.marginLeft = "19%";
//       container.style.overflowY = "auto";
//       container.style.height = "calc(100vh - 76px)";
//       container.style.width = "82%";
//       container.style.padding = "2px";
//     }
//   }, []);

//   return (
//     <>
//       <SideNav />

//       <div
//         className={
//           (navData1 === "iconopen" &&
//             "nav_right problems_pad_mar neg-marg-btm m-l-250 s-e-t-2") ||
//           (navData1 === "iconclose" &&
//             "nav_right1 problems_pad_mar neg-marg-btm m-l-250 s-e-t-2")
//         }
//       >
//         <div className="w-99 d-flex">
//           <DemographicsPatientDetail />

//           <div
//             id="care-summary"
//             className="appt-block-main m-t-0 schedule-comp1 w-82-5"
//           >
//             <CareSummaryWrapper />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CareSummary;
// CareSummary.jsx

import React, { useState, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideNav from "../../Sidenav";
import DemographicsPatientDetail from "../DemographicsPatientDetail";
import CareSummaryWrapper from "./CareSummaryWrapper";
import { GetSideNav } from "../../../StateManagement/Reducers/ScheduleState";
import "./CareSummary.css";

const CareSummary = () => {
  const [navData1, setNavData1] = useState("iconclose");

  const dispatch = useDispatch();

  const NavData1 = useSelector((state) => state.Schedule?.NavData);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  useEffect(() => {
    dispatch(GetSideNav("demographics"));
  }, []);

  useLayoutEffect(() => {
    const parentcontainer = document.querySelector(".pat-left-div");
    const container = document.getElementById("care-summary");

    if (parentcontainer && container) {
      parentcontainer.style.position = "fixed";
      parentcontainer.style.overflowY = "auto";
      parentcontainer.style.height = "calc(100vh - 76px)";
      parentcontainer.style.width = "16.5%";
      parentcontainer.style.paddingRight = "0px";

      container.style.marginLeft = "19%";
      container.style.overflowY = "auto";
      container.style.height = "calc(100vh - 76px)";
      container.style.width = "82%";
      container.style.padding = "2px";
    }
  }, []);

  return (
    <>
      <SideNav />

      <div
        className={
          (navData1 === "iconopen" &&
            "nav_right problems_pad_mar neg-marg-btm m-l-250 s-e-t-2") ||
          (navData1 === "iconclose" &&
            "nav_right1 problems_pad_mar neg-marg-btm m-l-250 s-e-t-2")
        }
      >
        <div className="w-99 d-flex">
          <DemographicsPatientDetail />

          <div
            id="care-summary"
            className="appt-block-main m-t-0 schedule-comp1 w-82-5"
          >
            <CareSummaryWrapper />
          </div>
        </div>
      </div>
    </>
  );
};

export default CareSummary;
